import axios from "axios";
import { useAppSelector } from "../hooks/storeHook";
import { userToken } from "../store/reducers/mainReducer";

const NetworkInstance1 = () => {
  const token = useAppSelector(userToken) || localStorage.getItem('talenvoJwToken');
  const networkInstance = axios.create({
    baseURL: `${process.env.REACT_APP_ROOT_URL}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // Add a response interceptor
networkInstance.interceptors.response.use(
  response => {
    // If the response is successful, just return it
    return response;
  },
  error => {
    const isAuthFlow = window.location.href.includes("auth")
    // If the response is unauthorized (401), redirect to the login page
    if (error.response && error.response.status === 401) {
      error.response.data.message = isAuthFlow ? "Sorry, Invalid Credentials " : "Your session has expired, you will be redirected to the login page.";
      if (!isAuthFlow) {
        setTimeout(() => {
          window.location.href = '/auth/login';
        }, 4000)
      }
    }
    // Return any other error to be handled
    return Promise.reject(error);
  }
); 


  return networkInstance;
};

export default NetworkInstance1;
